import { Skeleton } from '@shared/components/ui/shadcn';
import React from 'react';

export const PackagingCardSkeleton = React.memo(() => {
  return (
    <div
      className="dark:bg-card-bg border border-card-border rounded-xl p-4 bg-body-bg"
      data-testid="packaging-card-skeleton"
    >
      {/* Header - Skeleton del nombre */}
      <div className="flex justify-between items-start mb-4">
        <div className="flex-1 min-w-0">
          <Skeleton className="h-5 w-3/4 bg-hover-press" />
        </div>
      </div>

      {/* Contenido - Skeleton del SKU y categoría */}
      <div className="space-y-2 mt-2">
        {/* SKU */}
        <div className="flex items-center text-sm">
          <Skeleton className="w-3.5 h-3.5 rounded mr-2 bg-hover-press" />
          <Skeleton className="h-4 w-12 mr-2 bg-hover-press" />
          <Skeleton className="h-6 w-16 rounded-full bg-hover-press" />
        </div>
        {/* Categoría */}
        <div className="flex items-center text-sm">
          <Skeleton className="w-3.5 h-3.5 rounded mr-2 bg-hover-press" />
          <Skeleton className="h-4 w-24 bg-hover-press" />
        </div>
      </div>
    </div>
  );
});

PackagingCardSkeleton.displayName = 'PackagingCardSkeleton';

export default PackagingCardSkeleton;
